export const useHeaderAnimation = () => undefined;
export const useTitleAnimation = () => undefined;
